<template>
<div class="dashboard-top-header" v-if="isDashboard">
    <div class="dashboard-top-header-container" :class="{ 'no-border': isKycRoute }">
        <div class="logo">
            <img src="../../assets/logo.svg" alt="">
            <div class="name">OTCPro</div>
        </div>
        <div class="user" :class="{show: showProfileMenu}" v-if="userInfo" @click="onDashBoardClick()">
            <div class="my-user-card">
                <MenuOutlined v-if="!showProfileMenu" />
                <CloseOutlined v-else />
                <div class="initial">{{userInfo.initial}}</div>
                <div class="name">
                    <div class="display-name">{{userInfo.display_name}}</div>
                    <div class="email" v-if="userInfo.display_name!=userInfo.email">{{userInfo.email}}</div>
                </div>
                <BellFilled class="notification" v-if="showNotificationIcon" />
            </div>
            <transition name="fade">
                <div class="profile-menu" v-if="showProfileMenu&&!showMobileMenu">
                    <div class="profile-menu-user-card-container">
                        <div class="my-user-card" >
                            <div class="initial">{{userInfo.initial}}</div>
                            <div class="name">
                                <div class="display-name">{{userInfo.display_name}}</div>
                                <div class="email" v-if="userInfo.display_name!=userInfo.email">{{userInfo.email}}</div>
                            </div>
                            <BellFilled class="notification" v-if="showNotificationIcon" />
                        </div>
                    </div>
                    <div class="profile-menu-items">
                        <div class="profile-menu-item" v-if="currentPath=='/'" @click="() => { router.push({ path: `/dashboard` }) }">
                            <div>{{ i18n('global.menu.dashboard') }}</div>
                        </div>
                        <div class="profile-menu-item" @click="onProfileClick">
                            <div>{{ i18n('global.menu.my_profile') }}</div>
                            <div class="warning" v-if="!userInfo.identification_type || userInfo.identification_status == 'PENDING'">
                                <span>{{ i18n('global.menu.warning_id_not_verified') }}</span>
                            </div>
                        </div>
                        <div class="profile-menu-item" v-if="userInfo" @click="logout">
                            <div>{{ i18n('global.menu.btn_sign_off') }}</div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
    </div>
    <transition name="slide-down" >
        <div class="mobile-nav" v-if="showProfileMenu">
            <!-- 主菜单视图：key 含 userInfo 与 selectedMainMenuKey，确保 userInfo 就绪后菜单完整重渲染，解决刷新后菜单项不全需点击才全的问题 -->
            <div v-if="!showSubMenu" class="mobile-nav-main" :key="`main-menu-${selectedMainMenuKey || 'none'}-${userInfo?.identification_status ?? 'loading'}`">
                <div class="user" v-if="userInfo" @click="onDashBoardClick()">
                    <div class="my-user-card" >
                        <div class="initial">{{userInfo.initial}}</div>
                        <div class="name">
                            <div class="display-name">{{userInfo.display_name}}</div>
                            <div class="email">{{userInfo.email}}</div>
                        </div>
                    </div>
                </div>
                <a-menu class="mobile-nav-menu" :selectedKeys="selectedKeys" :default-selected-keys="['DASHOARD']" :openKeys="openKeys" mode="inline" :key="`menu-${selectedMainMenuKey || 'none'}-${userInfo?.identification_status ?? 'loading'}`">
                    <a-menu-item :title="i18n('global.menu.dashboard')" @click="onItemClick('/dashboard')" v-if="currentPath=='/' && userInfo">{{ i18n('global.menu.dashboard') }}</a-menu-item>
                    <!-- My Profile 选项 - 在手机端显示 -->
                    <a-menu-item key="PROFILE" :title="i18n('global.menu.my_profile')" class="side-nav-menu" @click="onProfileClick" v-if="userInfo">
                        {{ i18n('global.menu.my_profile') }}
                    </a-menu-item>
                    <!-- <a-menu-item v-for="menu in menus" :key="menu.path" :title="menu.name" @click="onItemClick(menu.path)">{{menu.name}}</a-menu-item> -->
                    <template v-for="menu in menus">
                        <!-- 手机模式下，有子菜单的项点击时显示二级菜单（使用 @titleClick 而不是 @click） -->
                        <a-menu-item 
                            v-if="menu.sub_menus.length>0" 
                            :key="menu.key" 
                            class="side-nav-menu mobile-sub-menu-trigger" 
                            @click="onSubMenuClick(menu)"
                        >
                            {{menu.title}}
                        </a-menu-item>
                        <a-menu-item v-else :key="menu.key" class="side-nav-menu" @click="onItemClick(menu.path||'/kyc')" :disabled="!menu.path" >
                            <!-- <template #icon>
                                <component :is="menu.icon" />
                            </template> -->
                            {{menu.title}}
                            
                        </a-menu-item>
                    </template>
                </a-menu>
                <a-menu
                    class="mobile-nav-menu mobile-nav-menu-logout"
                    v-if="userInfo"
                    >
                    <a-popconfirm
                        :title="i18n('global.menu.confirm_logout_title')"
                        :ok-text="i18n('global.menu.confirm_ok')"
                        :cancel-text="i18n('global.menu.confirm_cancel')"
                        @confirm="logout"
                    >
                        <a-menu-item class="side-nav-menu logout" >
                            <template #icon>
                                <LogoutOutlined />
                            </template>
                            <span>{{ i18n('global.menu.btn_sign_off') }}</span>
                        </a-menu-item>
                    </a-popconfirm>
                </a-menu>
                <div class="user" v-if="!userInfo">
                    <a-button type="link" size="large" @click="onSignUpClick" v-if="!isZpChannel">{{ i18n('global.menu.btn_sign_up') }}</a-button>
                    <a-button
                        type="primary"
                        size="large"
                        @click="onSignInClick"
                        :loading="zpLoading && isZpChannel"
                        :disabled="zpLoading && isZpChannel"
                    >
                        {{ zpLoading && isZpChannel ? (i18n('sign_in.zp_loading') || 'Authenticating...') : i18n('global.menu.btn_sign_in') }}
                    </a-button>
                </div>
            </div>
            <!-- 二级菜单视图（仅手机模式） -->
            <div v-else class="mobile-nav-sub">
                <div class="mobile-sub-menu-header">
                    <a-button type="text" class="back-button" @click="onBackToMainMenu">
                        <ArrowLeftOutlined />
                    </a-button>
                    <div class="sub-menu-title">{{ currentSubMenu?.title }}</div>
                </div>
                <a-menu 
                    class="mobile-nav-menu mobile-sub-menu" 
                    :selectedKeys="selectedSubKeys"
                >
                    <a-menu-item 
                        v-for="sub in currentSubMenu?.sub_menus" 
                        :key="sub.key" 
                        class="side-nav-menu" 
                        @click="onItemClick(sub.path||'/kyc')" 
                        :disabled="!sub.path"
                    >
                        {{sub.title}}
                    </a-menu-item>
                </a-menu>
            </div>
        </div>
    </transition>
</div>
</template>

<script setup lang="ts">
import { h, ref, reactive, computed, watch, onMounted, nextTick } from "vue";
import { MenuOutlined, BellFilled, CloseOutlined, WalletOutlined, UserOutlined, BookOutlined, SwapOutlined, DownloadOutlined, UploadOutlined, LogoutOutlined, ArrowLeftOutlined } from "@ant-design/icons-vue";
import { useStore } from "../../store" ;
import { useRoute, useRouter } from "vue-router";
import { useI18n } from 'vue-i18n'
import { message } from 'ant-design-vue';
const { t:i18n } = useI18n();
const route = useRoute();
const router = useRouter();
const store = useStore();

// Zp 渠道 loading（使用 store 全局状态，在 App.vue 显示居中转圈）
const zpLoading = computed(() => store.getters.zpAuthLoading);
const showMobileMenu = ref<Boolean>(false);
const showProfileMenu = ref<Boolean>(false);
// 手机端二级菜单相关状态
const showSubMenu = ref<Boolean>(false);
const currentSubMenu = ref<any>(null);
// 二级菜单的选中状态
const selectedSubKeys = ref<string[]>([]);

// const selectedKeys = ref([]);
const userInfo = computed(() => store.getters.userInfo );
const isZpChannel = computed(() => store.getters.isZpChannel);
const isMerchant = computed(() => Number(userInfo.value?.type) === 2);

const menus = computed(() => {
    const t = i18n;
    if(userInfo.value && userInfo.value.identification_status == 'VERIFIED') {
        let m = [
            { key: 'DASHOARD', title: t('global.menu.dashboard'), path: `/dashboard`, sub_menus:[] },
            { key: 'DEPOSIT', title: t('global.menu.deposits'), path: `/dashboard/deposit`, sub_menus:[] },
            { key: 'WITHDRAW', title: t('global.menu.withdrawals'), path: `/dashboard/withdraw`, sub_menus: [
                { key: 'WITHDRAW.RECENT', title: t('global.menu.make_withdrawals'), path: `/dashboard/withdraw` },
                { key: 'WITHDRAW.TOKEN_ADDRESS', title: t('global.menu.manage_crypto_addresses'), path: `/dashboard/withdraw/token` },
                { key: 'WITHDRAW.BANK_ACCOUNT', title: t('global.menu.manage_bank_accounts'), path: `/dashboard/withdraw/bank` },
            ] },
            { key: 'TRADE', title: t('global.menu.buy_sell'), path: `/dashboard/trade`, sub_menus:[] },
            { key: 'HISTORY', title: t('global.menu.history'), path: `/dashboard/history`, sub_menus:[] },
            { key: 'REFERRAL', title: t('global.menu.referral'), path: `/dashboard/referral`, sub_menus:[] },
            { key: 'SECURITY', title: t('global.menu.security'), path: `/dashboard/security`, sub_menus:[
                { key: 'SECURITY.UPDATE_PWD', title: t('global.menu.update_password'), path: `/dashboard/security` },
                { key: 'SECURITY.UPDATE_2FA', title: t('global.menu.update_2fa'), path: `/dashboard/security/2fa` },
            ] },
            { key: 'SUPPORT', title: t('global.menu.support'), path: `/dashboard/support`, sub_menus:[] },
        ];
        if(userInfo.value.dev_key_enabled == 1) {
            (m[6].sub_menus as Array<{ key: string; title: string; path: string }>).push({ key: 'SECURITY.UPDATE_DEV_API', title: t('global.menu.developer_api'), path: `/dashboard/security/developer` });
        }
        if(isMerchant.value) {
            (m[6].sub_menus as Array<{ key: string; title: string; path: string }>).push({ key: 'SECURITY.MERCHANT_SUB', title: t('global.menu.merchant_sub_accounts'), path: `/dashboard/security/merchant-sub-accounts` });
        }
        return m;
    }else if(userInfo.value && userInfo.value.authenticate_type != 'GENERAL_USER'){
        let m =[
        { key: 'KYC', title: t('global.menu.complete_kyc'), path: `/dashboard/kyc`, sub_menus:[] },
        { key: 'DASHOARD', title: t('global.menu.dashboard'), sub_menus:[] },
        { key: 'DEPOSIT', title: t('global.menu.deposits'), sub_menus:[] },
        { key: 'WITHDRAW', title: t('global.menu.withdrawals'), sub_menus:[]},
        { key: 'TRADE', title: t('global.menu.buy_sell'), sub_menus:[] },
        { key: 'REFERRAL', title: t('global.menu.referral'), sub_menus:[] },
        { key: 'SECURITY', title: t('global.menu.security'), path: `/dashboard/security`, sub_menus:[
                { key: 'SECURITY.UPDATE_PWD', title: t('global.menu.update_password'), path: `/dashboard/security` },
                { key: 'SECURITY.UPDATE_2FA', title: t('global.menu.update_2fa'), path: `/dashboard/security/2fa` },
            ] },
        { key: 'SUPPORT', title: t('global.menu.support'), path: `/dashboard/support`, sub_menus:[] },
    ]
    if(isMerchant.value) {
        (m[6].sub_menus as Array<{ key: string; title: string; path: string }>).push({ key: 'SECURITY.MERCHANT_SUB', title: t('global.menu.merchant_sub_accounts'), path: `/dashboard/security/merchant-sub-accounts` });
    }
    return m;
    }
    let m = [
        { key: 'KYC', title: t('global.menu.complete_kyc'), path: `/dashboard/kyc`, sub_menus:[] },
        { key: 'DASHOARD', title: t('global.menu.dashboard'), sub_menus:[] },
        { key: 'DEPOSIT', title: t('global.menu.deposits'), sub_menus:[] },
        { key: 'WITHDRAW', title: t('global.menu.withdrawals'), sub_menus:[]},
        { key: 'TRADE', title: t('global.menu.buy_sell'), sub_menus:[] },
        { key: 'REFERRAL', title: t('global.menu.referral'), sub_menus:[] },
        { key: 'SECURITY', title: t('global.menu.security'), path: `/dashboard/security`, sub_menus: [] as Array<{ key: string; title: string; path: string }> },
        { key: 'SUPPORT', title: t('global.menu.support'), path: `/dashboard/support`, sub_menus:[] },
    ];
    if(isMerchant.value) {
        (m[6].sub_menus as Array<{ key: string; title: string; path: string }>).push({ key: 'SECURITY.MERCHANT_SUB', title: t('global.menu.merchant_sub_accounts'), path: `/dashboard/security/merchant-sub-accounts` });
    }
    return m;
})

const currentPath = computed(() => {
    return route.path;
});

const openKeys = computed(() => {
    if(selectedKeys.value.length > 0) {
        return [selectedKeys.value[0].split('.')[0] + '1'];
    }
    return []
});

// 检查并自动显示二级菜单（如果当前路由匹配子菜单或主菜单路径）
const checkAndShowSubMenu = () => {
    if (showProfileMenu.value && window.innerWidth <= 910) {
        for(let i = 0; i < menus.value.length; i++ ) {
            const menu = menus.value[i];
            if(menu.sub_menus.length > 0) {
                // 先检查当前路由是否匹配该菜单的子菜单
                for(let j = 0; j < menu.sub_menus.length; j++ ) {
                    const subPath = menu.sub_menus[j].path;
                    if(subPath) {
                        // 使用精确匹配或路径开头匹配
                        if (currentPath.value === subPath || currentPath.value.startsWith(subPath + '/')) {
                            // 如果匹配，自动显示二级菜单
                            currentSubMenu.value = menu;
                            showSubMenu.value = true;
                            return;
                        }
                    }
                }
                // 如果子菜单都不匹配，检查是否匹配主菜单路径
                const mainPath = menu.path;
                if(mainPath) {
                    // 使用精确匹配或路径开头匹配
                    if (currentPath.value === mainPath || currentPath.value.startsWith(mainPath + '/')) {
                        // 如果匹配主菜单路径，也显示二级菜单
                        currentSubMenu.value = menu;
                        showSubMenu.value = true;
                        return;
                    }
                }
            }
        }
        // 如果没有匹配的菜单，隐藏二级菜单
        if (showSubMenu.value && !currentSubMenu.value) {
            showSubMenu.value = false;
        }
    }
}

watch(showProfileMenu, (status) => {
    store.commit('setMobileMenuOpenStatus', status);
    if (status && window.innerWidth <= 910) {
        // 未登录时始终显示主菜单（完整列表 + Sign up + Sign in），不自动切到二级视图
        if (!userInfo.value) {
            showSubMenu.value = false;
            currentSubMenu.value = null;
        }
        // 延迟一下，确保菜单已经渲染，再检查是否要显示二级菜单（仅已登录且当前路由匹配有子菜单的项）
        setTimeout(() => {
            checkAndShowSubMenu();
        }, 100);
    } else if (!status) {
        // 菜单关闭时，只隐藏二级菜单视图（但保留 currentSubMenu 用于下次判断）
        showSubMenu.value = false;
    }
});

// 监听路由变化，如果菜单打开且路由匹配子菜单，自动显示二级菜单
watch(currentPath, () => {
    if (showProfileMenu.value) {
        checkAndShowSubMenu();
    }
    // 路由变化时，更新选中状态
    const subKey = selectedSubMenuKey.value;
    selectedSubKeys.value = subKey ? [subKey] : [];
});

const isDashboard = computed(() => {
    return currentPath.value.startsWith('/dashboard');
});

const isKycRoute = computed(() => {
    return currentPath.value === '/dashboard/kyc' || currentPath.value.startsWith('/dashboard/kyc/');
});

const onMenuClick = () => {
    showMobileMenu.value = !showMobileMenu.value;
}
const onItemClick = async (path = '/') => {
    showProfileMenu.value = false;
    showSubMenu.value = false;
    currentSubMenu.value = null;
    // Zp 来源且未登录：与 Sign_in 一致，先 zpAuth 再跳转
    if (!userInfo.value && isZpChannel.value) {
        try {
            await store.dispatch('zpAuth');
            router.replace(path || '/dashboard');
        } catch (error: any) {
            if (error?.message === 'sign_in.zp_cancelled') return;
            message.error(error?.message === 'sign_in.zp_auth_failed' ? i18n('sign_in.zp_auth_failed') : (error?.message || (error && typeof error === 'object' ? JSON.stringify(error) : i18n('sign_in.zp_auth_failed'))));
        } finally {
            store.commit('setZpAuthLoading', false);
        }
        return;
    }
    if (!userInfo.value && !isZpChannel.value) {
        const redirectName = (path && path.includes('trade')) ? 'MyTrade' : 'Dashboard';
        router.push({ path: '/signin', query: { redirect: redirectName } });
        return;
    }
    router.push({ path: path || '/' });
}
// 手机模式下，点击有子菜单的项时显示二级菜单
const onSubMenuClick = (menu: any) => {
    // 只在手机模式下（屏幕宽度 <= 910px）显示二级菜单
    if (window.innerWidth <= 910) {
        currentSubMenu.value = menu;
        showSubMenu.value = true;
    } else {
        // 桌面模式下，如果有默认路径则跳转
        if (menu.path) {
            onItemClick(menu.path);
        }
    }
}
// 返回主菜单
const onBackToMainMenu = () => {
    showSubMenu.value = false;
    // 不重置 currentSubMenu，这样可以根据路由自动判断是否应该显示二级菜单
    // 如果当前路由匹配子菜单，下次打开菜单时会自动显示二级菜单
    // 返回主菜单后，selectedKeys 会根据当前路由自动更新，显示正确的选中状态
    // 使用 nextTick 确保视图更新，让菜单组件能正确响应 selectedKeys 的变化
    nextTick(() => {
        // selectedKeys 是 computed，会自动根据 selectedMainMenuKey 更新
        // 通过 key 的变化，强制菜单组件重新渲染，确保选中状态正确显示
    });
}
const onSignInClick = async () => {
    // 关闭菜单
    showProfileMenu.value = false;

    // 如果是 Zp 渠道，直接调用登录方法
    if (isZpChannel.value) {
        try {
            await store.dispatch('zpAuth');
            router.replace('/dashboard');
        } catch (error: any) {
            if (error?.message === 'sign_in.zp_cancelled') return;
            message.error(error?.message === 'sign_in.zp_auth_failed' ? i18n('sign_in.zp_auth_failed') : (error?.message || (error && typeof error === 'object' ? JSON.stringify(error) : i18n('sign_in.zp_auth_failed'))));
        } finally {
            store.commit('setZpAuthLoading', false);
        }
    } else {
        // 普通渠道，跳转到登录页面
        router.push({ path: `/signin` });
    }
}
const onSignUpClick = () => {
    router.push({ path: `/signup` });
    showProfileMenu.value = false;
}
const onDashBoardClick = () => {
    // router.push({ path: `/dashboard` });
    showMobileMenu.value = false;
    showProfileMenu.value = !showProfileMenu.value;
    // 关闭菜单时只隐藏二级菜单视图，但保留 currentSubMenu 用于下次判断
    if (!showProfileMenu.value) {
        showSubMenu.value = false;
        // 不重置 currentSubMenu，这样下次打开菜单时可以根据路由自动显示二级菜单
    }
}
const onDashboardMenuClick = (path:string) => {
    router.push({ path });
    showProfileMenu.value = false;
}

// const selectedDashboardMenuKeys = computed(() => {
//     let key:Array<any> = [];
//     for(let i = 0; i < menus.value.length; i++ ) {
//         if(currentPath.value.includes(menus.value[i].path)) {
//             key = [menus.value[i].key]
//         }
//     }
//     return key;
// });

// 获取当前选中的主菜单项（用于外层菜单显示）
const selectedMainMenuKey = computed(() => {
    // 检查是否是 My Profile 页面
    if (currentPath.value === '/dashboard/profile' || currentPath.value.startsWith('/dashboard/profile/')) {
        return 'PROFILE';
    }
    
    // 按路径长度从长到短排序所有菜单，优先匹配更具体的路径
    const allMenus = [];
    for(let i = 0; i < menus.value.length; i++ ) {
        const menu = menus.value[i];
        // 先收集所有子菜单
        if(menu.sub_menus.length > 0) {
            for(let j = 0; j < menu.sub_menus.length; j++ ) {
                const subPath = menu.sub_menus[j].path;
                if(subPath) {
                    allMenus.push({
                        key: menu.key,
                        path: subPath,
                        isSubMenu: true
                    });
                }
            }
        }
        // 再收集主菜单路径
        if(menu.path) {
            allMenus.push({
                key: menu.key,
                path: menu.path,
                isSubMenu: false
            });
        }
    }
    
    // 按路径长度从长到短排序
    allMenus.sort((a, b) => {
        return b.path.length - a.path.length; // 降序排列
    });
    
    // 优先匹配更具体的路径
    for(let i = 0; i < allMenus.length; i++ ) {
        const menuItem = allMenus[i];
        if (currentPath.value === menuItem.path || currentPath.value.startsWith(menuItem.path + '/')) {
            return menuItem.key;
        }
    }
    
    return null;
});

// 获取当前选中的子菜单项（用于二级菜单显示）
const selectedSubMenuKey = computed(() => {
    if (!currentSubMenu.value) return null;
    
    // 按路径长度从长到短排序，优先匹配更具体的路径
    const sortedSubMenus = [...currentSubMenu.value.sub_menus].sort((a, b) => {
        const aLen = a.path ? a.path.length : 0;
        const bLen = b.path ? b.path.length : 0;
        return bLen - aLen; // 降序排列
    });
    
    for(let j = 0; j < sortedSubMenus.length; j++ ) {
        const subPath = sortedSubMenus[j].path;
        if(subPath) {
            // 使用精确匹配或路径开头匹配，确保能正确匹配
            if (currentPath.value === subPath || currentPath.value.startsWith(subPath + '/')) {
                return sortedSubMenus[j].key;
            }
        }
    }
    return null;
});

// 主菜单的选中状态
const selectedKeys = computed(() => {
    const mainKey = selectedMainMenuKey.value;
    return mainKey ? [mainKey] : [];
});

// 监听 selectedSubMenuKey 和 currentSubMenu 变化，更新 selectedSubKeys
watch([selectedSubMenuKey, currentSubMenu], () => {
    const subKey = selectedSubMenuKey.value;
    selectedSubKeys.value = subKey ? [subKey] : [];
}, { immediate: true, deep: true });

const logout = () => {
    router.replace(`/signin`);
    store.dispatch('setAccessToken');
}
const onProfileClick = () => {
    router.push({ path: `/dashboard/profile` });
    showProfileMenu.value = false;
}
const showNotificationIcon = computed(() => {
    if(!userInfo.value.identification_type) return true;
    if(userInfo.value.identification_status == 'PENDING') return true;
    return false;
});
</script>

<style lang="less">
.dashboard-top-header {
    display: flex;
    position: absolute;
    height: auto;
    z-index: 5;
    width: calc(100% - 300px);
    padding: 0 2em;
    right: 0px;
    top: 0px;
    @media screen and (max-width: 910px) {
        width: 100%;
        padding: 0em;
    }
    
    .dashboard-top-header-container {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        flex-wrap: wrap;
        height: 113px;
        background-color: #FFF;
        position: relative;
        width: 100%;
        transition: 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
        z-index: 7;
        border-bottom: 1px solid #ccc;
        &.no-border {
            border-bottom: none;
        }
        @media screen and (max-width: 910px) {
            justify-content: space-between;
            padding: 0 20px;
        }
        @media screen and (max-width: 415px) {
            height: 80px;
            justify-content: space-between;
            padding: 0 16px;
        }
        .logo {
            display: none;
            flex-wrap: wrap;
            color: @primary-color;
            font-weight: 800;
            align-items: center;
            justify-content: center;
            align-content: center;
            @media screen and (max-width: 910px) {
                display: flex;
            }
            img {
                width: 50px;
                border-radius: 8px;
                margin: 8px;
                @media screen and (max-width: 415px) {
                    width: 34px;
                    margin: 4px;
                }
            }
            .name {
                font-size: 32px;
                @media screen and (max-width: 415px) {
                    font-size: 28px;
                }
            }
        }
        .user {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            position: relative;
            cursor: pointer;
            min-width: 200px;
            .anticon {
                display: none;
            }
            @media screen and (max-width: 910px) {
                min-width: auto;
                height: 42px;
                .anticon {
                    display: block;
                    font-size: 32px;
                }
            }
            .my-user-card {
                display: flex;
                line-height: 1em;
                align-items: center;
                justify-content: center;
                color:#333;
                padding: 0.6em 1em;
                width: 100%;
                position: relative;
                .initial {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 20px;
                    width: 50px;
                    height: 50px;
                    border-radius: 50%;
                    background-color: @primary-color;
                    
                    @media screen and (max-width: 910px) {
                        display: none;
                    }
                }
                .name {
                    margin-left: 0.5em;
                    max-width: 160px;
                    line-height: 1.4em;
                    @media screen and (max-width: 910px) {
                        display: none;
                    }
                    .display-name {
                        font-size: 18px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap; 

                    }
                    .email {
                        font-size: 14px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }
                }
                .notification {
                    font-size: 0.8em;
                    background-color: rgb(174, 0, 0);
                    color: #FFF;
                    border-radius: 50%;
                    padding: 5px;
                    position: absolute;
                    right: 4px;
                    top: 4px;
                    opacity: 0.7;
                    transition: 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
                }
                &:hover {
                    .notification {
                        opacity: 1;
                        transform: scale(1.1);
                    }
                }
            }
            
            .profile-menu {
                position: absolute;
                top: 0;
                left: 0;
                opacity: 0;
                background-color: #FFF;
                border-radius: 8px;
                box-shadow: 0px 1.66744px 16.6744px rgba(0, 0, 0, 0.1);
                transition: 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
                width: 100%;
                
                @media screen and (max-width: 900px) {
                    display: none;
                }
                .profile-menu-user-card-container {
                    padding-bottom: 16px;
                    display: flex;
                    align-items: flex-start;
                    @media screen and (max-width: 415px) {
                        height: 81px;
                    }
                }
                .profile-menu-items {
                    line-height: 1.8em;
                    padding: 1em 0em;
                    background-color: rgba(0,0,0,0.02);
                    .profile-menu-item {
                        padding: 0.5em 1em;
                        cursor: pointer;
                        transition: 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
                        display: flex;
                        flex-direction: column;
                        &:hover {
                            color: @primary-color;
                            background-color: rgba(0, 0, 0, 0.03);
                        }
                        .warning {
                            color: #ae0000;
                            font-size: 0.6em;
                            line-height: 1em;
                            font-style: italic;
                        }
                    }
                }
            }
            &.show {
                cursor: default;
                .profile-menu {
                    opacity: 1;
                }
            }
        }
        .nav-show-btn {
            display: none;
            & > * {
                font-size: 30px;
            }
            @media screen and (max-width: 910px) {
                display: block;
            }
        }
    }
    .mobile-nav {
        width: 100%;
        display: none;
        padding: 32px 0px;
        background-color: rgba(255, 255, 255, 0.8);
        box-shadow: 0 8px 20px -16px rgba(0,0,0,0.3) inset;
        height: calc(100vh - 114px);
        position: absolute;
        backdrop-filter: blur(5px);
        -webkit-backdrop-filter: blur(5px);
        z-index: 100;
        top: 114px;
        left: 0px;
        @media screen and (max-width: 910px) {
            display: block;
            overflow-y: auto;
            overflow-x: hidden;
            -webkit-overflow-scrolling: touch;
            padding-bottom: 120px; // 为底部按钮预留足够空间，避免被浏览器输入框遮挡
        }
        @media screen and (max-width: 415px) {
            height: calc(100vh - 80px);
            top: 80px;
            display: flex;
            flex-direction: column;
            padding: 0px;
            // 为底部按钮预留足够空间，避免被浏览器输入框遮挡
            // 支持 iOS Safari 底部安全区域
            padding-bottom: calc(120px + env(safe-area-inset-bottom, 0px));
            overflow-y: auto;
            overflow-x: hidden;
            -webkit-overflow-scrolling: touch;
            // 确保内容可以滚动到底部
            min-height: 0;
        }
        .mobile-nav-menu {
            font-size: 20px;
            border-bottom: none;
            border-right: none;
            background-color: transparent;
            text-align: center;
            @media screen and (max-width: 415px) {
                font-size: 16px;
                line-height: 40px
            }
            // 最后一个菜单（Sign Off）添加额外的底部间距
            &.mobile-nav-menu-logout {
                margin-bottom: 20px;
                @media screen and (max-width: 415px) {
                    margin-bottom: 30px;
                }
            }
            .ant-menu-item {
                line-height: 60px;
                padding: 0px;
                padding-right: 0px !important;
                padding-left: 0px !important;
                height: 60px;
                margin: 0;
                user-select: none;
                @media screen and (max-width: 415px) {
                    line-height: 50px;
                    height: 50px;
                }
                .ant-menu-title-content {
                    text-align: center;
                    @media screen and (max-width: 415px) {
                        line-height: 50px
                    }
                }
                &:active {
                    background-color: rgb(67, 67, 67);
                    color: @primary-color
                }
                // 手机模式下，有子菜单的项显示右箭头
                &.mobile-sub-menu-trigger {
                    position: relative;
                    &::after {
                        content: '›';
                        position: absolute;
                        right: 20px;
                        font-size: 24px;
                        color: #999;
                        @media screen and (max-width: 415px) {
                            right: 16px;
                            font-size: 20px;
                        }
                    }
                }
            }
            .ant-menu-submenu {
                display: flex;
                flex-direction: column;
                min-height: 40px;
                height: auto;
                border-right: none;
                .ant-menu-submenu-title {
                    padding: 0px;
                    padding-left: 0px !important;
                    margin: 0px;
                }
                .ant-menu-sub {
                    background-color: transparent;
                    padding: 16px 0px;
                    .ant-menu-item {
                        height: 30px;
                        .ant-menu-title-content {
                            line-height: 30px;
                        }
                        &:hover {
                            color: #00B77E;
                        }
                        &.ant-menu-item-selected {
                            background-color: transparent;
                            color: #00B77E;
                        }
                    }
                }
            }
            .ant-menu-item-selected {
                background-color: #333;
                &::after {
                    display: none;
                }
            }
            .ant-menu-submenu-arrow {
                display: none;
            }
        }
        .user {
            
            padding: 1em 0em;
            align-items: center;
            justify-content: center;
            align-content: center;
            display: none;
            @media screen and (max-width: 910px) {
                display: flex;
                flex-direction: column-reverse;
            }
            .my-user-card {
                display: flex;
                line-height: 1em;
                align-items: center;
                justify-content: flex-start;
                border-radius: 8px;
                background-color: #eee;
                padding: 1em;
                color:#333;
                .initial {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 50px;
                    height: 50px;
                    border-radius: 50%;
                    background-color: @primary-color;
                    font-size: 1.3em;
                }
                .name {
                    margin-left: 0.5em;
                    font-size: 20px;
                    .display-name {
                        line-height: 1.5em;
                    }
                    .email {
                        font-size: 14px;
                    }
                }
            }
        }
        // 主菜单视图
        .mobile-nav-main {
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
        }
        // 二级菜单视图（仅手机模式）
        .mobile-nav-sub {
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            animation: slideInRight 0.3s ease-out;
            @media screen and (min-width: 911px) {
                display: none; // 桌面模式不显示二级菜单
            }
            .mobile-sub-menu-header {
                display: flex;
                align-items: center;
                padding: 16px 20px;
                border-bottom: 1px solid #eee;
                background-color: #fff;
                position: sticky;
                top: 0;
                z-index: 10;
                box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
                @media screen and (max-width: 415px) {
                    padding: 12px 16px;
                }
                .back-button {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: #333;
                    padding: 8px;
                    width: 40px;
                    height: 40px;
                    border-radius: 6px;
                    transition: all 0.3s;
                    @media screen and (max-width: 415px) {
                        padding: 6px;
                        width: 36px;
                        height: 36px;
                    }
                    &:hover {
                        color: @primary-color;
                        background-color: rgba(0, 0, 0, 0.03);
                    }
                    &:active {
                        background-color: rgba(0, 0, 0, 0.05);
                    }
                    .anticon {
                        font-size: 20px;
                        @media screen and (max-width: 415px) {
                            font-size: 18px;
                        }
                    }
                }
                .sub-menu-title {
                    flex: 1;
                    font-size: 20px;
                    font-weight: 600;
                    color: #333;
                    text-align: center;
                    margin-right: 40px; // 平衡返回按钮的宽度（只有箭头，不需要太多空间）
                    @media screen and (max-width: 415px) {
                        font-size: 18px;
                        margin-right: 36px;
                    }
                }
            }
            .mobile-sub-menu {
                flex: 1;
                overflow-y: auto;
                padding-top: 16px;
                padding-bottom: 20px;
                .ant-menu-item {
                    line-height: 60px;
                    padding: 0px;
                    padding-right: 0px !important;
                    padding-left: 0px !important;
                    height: 60px;
                    margin: 0;
                    user-select: none;
                    border-radius: 0;
                    transition: all 0.3s;
                    @media screen and (max-width: 415px) {
                        line-height: 50px;
                        height: 50px;
                    }
                    .ant-menu-title-content {
                        text-align: center;
                        padding: 0 20px;
                        @media screen and (max-width: 415px) {
                            padding: 0 16px;
                            line-height: 50px;
                        }
                    }
                    &:hover {
                        background-color: rgba(0, 0, 0, 0.03);
                    }
                    &:active {
                        background-color: rgb(67, 67, 67);
                        color: @primary-color;
                    }
                    &.ant-menu-item-selected {
                        background-color: #333;
                        color: @primary-color;
                        &::after {
                            display: none;
                        }
                    }
                }
            }
        }
        // 主菜单视图动画
        .mobile-nav-main {
            animation: slideInLeft 0.3s ease-out;
        }
    }
}

// 二级菜单滑入动画
@keyframes slideInRight {
    from {
        transform: translateX(100%);
        opacity: 0;
    }
    to {
        transform: translateX(0);
        opacity: 1;
    }
}

// 主菜单滑入动画
@keyframes slideInLeft {
    from {
        transform: translateX(-100%);
        opacity: 0;
    }
    to {
        transform: translateX(0);
        opacity: 1;
    }
}
</style>